import * as React from "react";
import Ajax from "../../Ajax";
import swal from 'sweetalert';
import InputMask from 'react-input-mask';
import Service from "./Service";
import {ChangeEvent} from "react";

interface IFormProps {
    type: object,
    loadCart: any,
    session_id: any,
    services_serial: number,
    noServicesNeeded?: boolean,
    onNoServicesChecked: (checked: boolean) => void,
    cartItems: any

}
interface MyStates {
    ajaxLoaded: boolean,
    spinner: string,
    type: object,


}
export default class TypeServices extends React.Component<IFormProps, MyStates>{

    constructor(props:IFormProps) {
        super(props);

        this.state = {
            ajaxLoaded: true,
            spinner: 'none',
            type: this.props.type,

        }
    }

    private handleNoServicesChanged(e: ChangeEvent<HTMLInputElement>) {
        this.props.onNoServicesChecked(e.target.checked);
    }

    public render() {

        const hasCartItem = Array.from(this.props?.cartItems).filter((cartItem) => cartItem['service_serial'] == this.props.services_serial).length > 0;

        return (
            <>
                {
                    Object.keys(this.state.type?.['services']).map( (i) => {
                        let service = this.state.type['services'][i]
                        return (
                            <>
                                <div className="row service" key={"service_" + i}>

                                    <Service
                                        session_id={this.props.session_id}
                                        serial={this.props.services_serial}
                                        service={service}
                                        loadCart={() => this.props.loadCart()}
                                    />

                                </div>

                            </>
                        )
                    })
                }


                {
                    !hasCartItem &&
                    <div className="row float-right">
                        <div className="col-md-12 form-group">
                            <div className="input-group" style = {{width: '50%', float: 'right'}}>
                            <span className="input-group-addon height-34px">
                                Nem kívánok a {this.state.type['name']} szolgáltatásaiból foglalni
                            </span>
                                <span className="input-group-addon">
                                <input
                                    type="checkbox"
                                    name={`no_services_${this.props.services_serial}`}
                                    defaultChecked={Boolean(this.props.noServicesNeeded ?? false)}
                                    onChange={(e) => this.handleNoServicesChanged(e)}
                                />
                            </span>
                            </div>
                        </div>
                    </div>
                }


            </>
        )
    }
}